<template>
    <div class="guide-date">
        <div class="guide-date__days">{{ textDays }}</div>
        <div class="guide-date__date" :class="{'guide-date__date_capitalize': isFrench}" >{{ textDate }}</div>
    </div>
</template>

<script setup lang="ts">
    import { useApplicationStore } from "@/stores/Application";
    import {TimeUtils} from "@/utils";
    import {Strings} from "@/locales/types/enums";
    import { useI18n } from "vue-i18n";
    import {computed} from "vue";
    import { useGuideStore } from "@/stores/Guide";
    import { storeToRefs } from 'pinia';
    import { LangCodes } from "@/common/types/languages";

    const ApplicationStore = useApplicationStore();
    const {
        getCurrentTime: currentTime,
    } = storeToRefs(ApplicationStore);

    const GuideStoreModule = useGuideStore();
    const {
        focusedProgram,
    } = storeToRefs(GuideStoreModule)

    const { t, locale } = useI18n();

    const focusedTime = computed((): number | null => {
        return focusedProgram.value && focusedProgram.value.recentAirTime !== null ? focusedProgram.value.recentAirTime?.startTime : currentTime.value;
    });
    const textDays = computed((): string => {
        if (focusedTime.value === null) {
            return '';
        }
        const focusedDay = new Date(focusedTime.value);
        focusedDay.setHours(0, 0, 0, 0);

        const currentDay = new Date(currentTime.value);
        currentDay.setHours(0, 0, 0, 0);

        const diff = Math.floor((focusedDay.getTime() - currentDay.getTime()) / (24 * 60 * 60 * 1000));

        let dayOfWeek = '';
        switch (diff) {
            case -1:
                dayOfWeek = t(Strings.GUIDE_YESTERDAY).toString();
                break;
            case 0:
                dayOfWeek = t(Strings.GUIDE_TODAY).toString();
                break;
            case 1:
                dayOfWeek = t(Strings.GUIDE_TOMORROW).toString();
                break;
            default:
                dayOfWeek = TimeUtils.getMoment(locale.value, focusedTime.value)
                    .format('ddd')
                    .toUpperCase();
        }

        return `${dayOfWeek}`;
    });
    const isFrench = computed((): boolean => locale.value === LangCodes.FR);
    const textDate = computed((): string => {
        if (focusedTime.value === null) {
            return '';
        }

        const dateType = isFrench.value ? 'D MMM' : 'MMM D';
        return TimeUtils.getMoment(locale.value, focusedTime.value).format(dateType);
    });
</script>
